export class OutdatedError extends Error {
	constructor(model) {
		// Pass remaining arguments (including vendor specific ones) to parent constructor
		const message = `The data of '${model}' is outdated, but the app is offline`;
		super(message);

		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, OutdatedError);
		}

		this.name = "OutdatedError";
		this.model = model;
	}
}
